import React, { Fragment, useState, useEffect } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import InputComponent from "../../components/InputComponent";
import SelectComponent from "../../components/SelectComponent";
import stylebtn from "../../styles/btn.module.scss";
import stylegeneral from "../../styles/general.module.scss";
import styleform from "../../styles/form.module.scss";
import { BuscarCliente, PostCliente } from "../../api/ApiVenta";
import ParrafoComponent from "../../components/ParrafoComponent";
import { getClases } from "../../api/Clase";
import { FiltrarProducto } from "../../api/Filters";
import { getTipos } from "../../api/Tipo";
import { PostPersona } from "../../api/Empleado";
import stylegenral from "../../styles/general.module.scss";
import {
  EliminarFactura,
  PostAbonoFactura,
  Postfactura,
  PostfacturaDetalle,
} from "../../api/Factura";
import LoaderComponent from "../../components/LoaderComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import { Icon } from "@iconify/react/dist/iconify.js";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import styleBtn from "../../styles/btn.module.scss";
import { Link, useNavigate } from "react-router-dom";
import TitleH4Component from "../../components/TitleH4Component";
import { useAuth } from "../../context/AuthContext";
import { getTransporte } from "../../api/transporte";
import { abrirPdfVentas } from "../../api/Pdf";
const CotizacionPage = () => {
  const [mensaje, setMensaje] = useState("");
  const [optionsclass, setOptionsClass] = useState([]);
  const [selectedOptionClass, setSelectedOptionClass] = useState(null);
  const [optionstype, setOptionstype] = useState([]);
  const [selectedOptionType, setSelectedOptionType] = useState(null);
  const [dimensionOpcion, setDimensionOpcion] = useState([]);
  const [selectedOptionDimension, setSelectedOptionDimension] = useState(null);
  const [cantidad, setCantidad] = useState("");
  const [currentProducto, setCurrentProducto] = useState([]);
  const [cotizacion, setCotizacion] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [totalPago, setTotalPago] = useState(0);
  const [control, setcontrol] = useState(false);
  const [fechaPago, setFechaPago] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentCliente, setCurrentCliente] = useState([]);
  const [idCliente, setIdCliente] = useState("");
  const [currentPersona, setCurrentPersona] = useState([]);
  const [showCotizacion, setShowCotizacion] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [idfactura, serIdfactura] = useState(null);
  const [showEliminar, setShowEliminar] = useState(false);
  const [currentCarrito, setCurrentCarrito] = useState([]);
  const [dataTransporte, setDatTransporte] = useState([]);
  const { idUser } = useAuth();
  const [transporte, setTransporte] = useState('')
  const [dataConductor, setDataConductor] = useState([]);
  const [descripcionAbono, setDescripcionAbono] = useState("");
  const navigate = useNavigate();
  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  const [formDataFactura, setFormDataFactura] = useState({
    transporte: "",
    nombre_conductor: "",
    celular_conductor: "",
    quien_recibe: "",
    direccion_envio: "",
  });

  // Metodos para el popup del cliente
  const handleCloseCotizacion = () => {
    setShowCotizacion(false);
  };

  const handleShowCotizacion = () => {
    setShowCotizacion(true);
  };

  //Metodo para capturar los valotes de la descripcion
  const handleChangeDescripcion = (event) => {
    setDescripcionAbono(event.target.value);
  };


  const [checkboxes, setCheckboxes] = useState({
    isCheckedDescuento: false,
    isCheckedpago: false,
    isTransporte: false,
  });

  // este es el metodo para sacar el valor del check
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));
  };

  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);
  const handleShowEliminar = (item) => {
    setShowEliminar(true);
    setCurrentCarrito(item);
  };

  // metodo para eliminar del carrito de compra
  const eliminarItem = () => {
    const nuevoCarrito = cotizacion.filter(
      (item) => item.id !== currentCarrito?.id
    );
    setCotizacion(nuevoCarrito);
    localStorage.setItem("cotizacion", JSON.stringify(nuevoCarrito));
    handleCloseEliminar();
  };

  // Manejar el cambio en el input para las fechas de pagos
  const handleInputChangefechapago = (event) => {
    setFechaPago(event.target.value);
  };

  // Manejar el cambio en el input para los descuentos
  const handleInputPago = (event) => {
    setTotalPago(event.target.value);
  };
  // Manejar el cambio en el input para los descuentos
  const handleInputChangedescuento = (event) => {
    setDescuento(event.target.value);
  };

  // Manejar el cambio en el input
  const handleInputChange = (event) => {
    setCantidad(event.target.value);
  };

  // Manejar el cambio en el input
  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({
      ...formDataPersona,
      [name]: value,
    });
  };

  const handleInputChangeFactura = (event) => {
    const { name, value } = event.target;
    setFormDataFactura({
      ...formDataFactura,
      [name]: value,
    });
  };

  useEffect(() => {
    getClases()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionsClass(formattedOptions);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  useEffect(() => {
    getTipos()
      .then((response) => {
        const formattedOptions = response?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionstype(formattedOptions);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, []);

  // metodo para consultar la cc
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      consultarCedula();
    }
  };

  // metodo para verificar el cliente antes de registrar la compra
  const verificarCliente = () => {
    consultarCedula();
  };

  const consultarCedula = async () => {
    try {
      const res = await BuscarCliente(formDataPersona.cedula);
      setcontrol(res.success);
      if (res.success) {
        setFormDataPersona({
          cedula: res?.data?.cedula,
          nombre: res?.data?.nombre,
          apellido: res?.data?.apellido,
          direccion: res?.data?.direccion,
          celular: res?.data?.celular,
        });
        setCurrentPersona(res?.data);
        setIdCliente(res?.data?.Clientes[0]?.id);
        setCurrentCliente(res?.data?.Clientes);
        localStorage.setItem("cliente", JSON.stringify(res?.data));
      } else {
        /*setIdCliente('')*/

        setMensaje(res.msg);
        setFormDataPersona({
          cedula: formDataPersona.cedula,
          nombre: "",
          apellido: "",
          direccion: "",
          celular: "",
        });
      }

      /*setcontrol(res.success)*/
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  // metodo para buscar un producto

  //metodo de filtro
  useEffect(() => {
    filtroproducto();
  }, [selectedOptionClass, selectedOptionType, selectedOptionDimension]);

  const filtroproducto = () => {
    FiltrarProducto({
      idClase: selectedOptionClass ?? "",
      idTipo: selectedOptionType ?? "",
      dimension: selectedOptionDimension ?? "",
    })
      .then((response) => {
        const formattedOptionsDimension = response?.data?.map((item) => ({
          value: item.dimension,
          label: item.dimension,
        }));
        setDimensionOpcion(formattedOptionsDimension);
        setCurrentProducto(response?.data[0]);
      })
      .catch((error) => console.error(error));
  };

  // metodo para agregar a la cotizacion
  const aggCotizacion = () => {
    if (
      selectedOptionClass === "" ||
      selectedOptionType === "" ||
      selectedOptionDimension === "" ||
      cantidad === ""
    ) {
      setMensaje("Los campos son obligatorios **");
    } else {
      const carritoActual =
        JSON.parse(localStorage.getItem("cotizacion")) || [];

      // Verificar si el producto ya existe en la cotizacion
      const productoExistente = carritoActual.find(
        (producto) => producto.id === currentProducto?.id
      );
      // Si no existe, crear el nuevo objeto de compra
      if (productoExistente) {
        const nuevaCantidad =
          Number(productoExistente.pendientePorEntregar) + Number(cantidad);
        productoExistente.pendientePorEntregar = nuevaCantidad;
        productoExistente.valorTotalPorProducto =
          nuevaCantidad * Number(currentProducto?.precioVenta);
      } else {
        const nuevoProducto = {
          id: currentProducto?.id,
          clase: currentProducto?.Clase?.name,
          tipo: currentProducto?.Tipo?.name,
          dimension: currentProducto?.dimension,
          cantidad: 0,
          valorTotalPorProducto: Number(cantidad) * Number(currentProducto?.precioVenta),
          valorPorUnidad: Number(currentProducto?.precioVenta),
          pendientePorEntregar: Number(cantidad),
        };

        // Agregar el nuevo producto al carrito
        carritoActual.push(nuevoProducto);
      }

      localStorage.setItem("cotizacion", JSON.stringify(carritoActual));
      setCotizacion(carritoActual);
    }

    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  useEffect(() => {
    const carritoActual = JSON.parse(localStorage.getItem("cotizacion")) || [];
    setCotizacion(carritoActual);
  }, []);

  // useEffect para recalcular el total cuando cambie el carrito
  useEffect(() => {
    const calcularTotal = (cotizacion) => {
      return cotizacion.reduce(
        (total, item) => total + item.valorTotalPorProducto,
        0
      );
    };

    // Actualiza el total cada vez que 'carrito' cambie
    const total = calcularTotal(cotizacion);
    setSubTotal(total);
  }, [cotizacion]);


  // metodo para crear una cotizacion
  const craeteCotizacion = async (e) => {
    e.preventDefault();

    try {
      let total = 0;
      let descuentototal = 0;
      let financiado = 0;
      let estado = 2;
      let isventa = false;
      let tipo = "cotizacion";
      let descripcion = "Abono inicial " + descripcionAbono;

      // para validar si se aplicara el descuento
      if (checkboxes.isCheckedDescuento) {
        total = subTotal;
        descuentototal = descuento;
      } else {
        total = subTotal;
        descuentototal = 0;
      }
      if (checkboxes.isCheckedpago) {
        financiado = total + Number(formDataFactura.transporte) - totalPago;
        tipo = "venta";
        // verificamos que la factura este pendiente o financiada
        if (financiado === 0) {
          estado = 2;
        } else {
          estado = 1;
        }
      }


      if (
        formDataPersona.cedula === "" ||
        formDataPersona.nombre === "" ||
        formDataPersona.apellido === ""
      ) {
        setMensaje("Antes de realizar la cotizacion de asignar un cliente");
      } else if (!cotizacion || cotizacion.length === 0) {
        setMensaje(
          "Antes de realizar la cotizacion debe asignar los productos"
        );
      } else if (
        fechaPago === null &&
        financiado > 0 &&
        checkboxes.isCheckedpago
      ) {
        setMensaje(
          "Antes de realizar la cotizacion debe ingresar la fecha limite de pago"
        );
      } else {

        // si la perosna no exite en la base de datos
        if (!control || control == false) {
          const respersona = await PostPersona(formDataPersona);
          if (respersona.success) {
            setLoading(true);
            handleShowCotizacion();
            const rescliente = await PostCliente(respersona.data.idP);

            if (rescliente.success) {
              const resf = await Postfactura(
                transporte,
                idUser,
                rescliente.data.id,
                estado,
                subTotal,
                fechaPago,
                descuentototal,
                financiado,
                total,
                parseFloat(formDataFactura.transporte) || 0,
                tipo,
                formDataFactura.quien_recibe,
                formDataFactura.direccion_envio
              );

              if (resf?.success) {

                // en esta parte se agrega el abono solo si la factura es financiada 
                if (checkboxes.isCheckedpago && financiado > 0 && totalPago > 0) {
                  await PostAbonoFactura(resf.data.id, totalPago, descripcion, idUser);

                }
                const resFD = await PostfacturaDetalle(
                  isventa,
                  resf.data.id,
                  cotizacion
                );

                if (resFD?.success) {
                  //setCompraExitosa(true);
                  // Ahora limpiamos el carrito.
                  localStorage.removeItem("cotizacion");
                  setLoading(false);
                  serIdfactura(resf.data.id);
                } else {
                  await EliminarFactura(resf.data.id);
                  setMensaje("Fallo la compra, revise y vuelva a intentarlo");
                  setLoading(false);
                }
              }
            }
          }
          setMensaje(respersona.msg);

        } else {
          setLoading(true);
          handleShowCotizacion();
          // si la persona existe en la base de datos pero no es cliente
          if (idCliente === undefined || currentCliente?.length === 0) {
            const rescliente = await PostCliente(currentPersona?.idP);

            if (rescliente.success) {
              const resf = await Postfactura(
                transporte,
                idUser,
                rescliente.data.id,
                estado,
                subTotal,
                fechaPago,
                descuentototal,
                financiado,
                total,
                parseFloat(formDataFactura.transporte) || 0,
                tipo,
                formDataFactura.quien_recibe,
                formDataFactura.direccion_envio
              );


              if (resf?.success) {
                const resFD = await PostfacturaDetalle(
                  isventa,
                  resf.data.id,
                  cotizacion
                );

                // en esta parte se agrega el abono solo si la factura es financiada 
                if (checkboxes.isCheckedpago && financiado > 0 && totalPago > 0) {
                  await PostAbonoFactura(resf.data.id, totalPago, descripcion, idUser);
                }

                if (resFD?.success) {
                  //setCompraExitosa(true);
                  // Ahora limpiamos el carrito.
                  localStorage.removeItem("cotizacion");
                  setLoading(false);
                  serIdfactura(resf.data.id);
                } else {
                  await EliminarFactura(resf.data.id);
                  setMensaje("Fallo la compra, revise y vuelva a intentarlo");
                  setLoading(false);
                }
              }
            }
          } else {
            // Si la perosona es cliente
            if (idCliente !== "") {
              const resf = await Postfactura(
                transporte,
                idUser,
                idCliente,
                estado,
                subTotal,
                fechaPago,
                descuentototal,
                financiado,
                total,
                parseFloat(formDataFactura.transporte) || 0,
                tipo,
                formDataFactura.quien_recibe,
                formDataFactura.direccion_envio
              );


              if (resf?.success) {
                const resFD = await PostfacturaDetalle(
                  isventa,
                  resf.data.id,
                  cotizacion
                );

                // en esta parte se agrega el abono solo si la factura es financiada 
                if (checkboxes.isCheckedpago && financiado > 0 && totalPago > 0) {
                  await PostAbonoFactura(resf.data.id, totalPago, descripcion, idUser);

                }

                if (resFD?.success) {
                  //setCompraExitosa(true);
                  // Ahora limpiamos el carrito.
                  localStorage.removeItem("cotizacion");
                  setLoading(false);
                  serIdfactura(resf.data.id);
                } else {
                  await EliminarFactura(resf.data.id);
                  setMensaje("Fallo la compra, revise y vuelva a intentarlo");
                  setLoading(false);
                }
              }
            }
          }
        }

        /* esta es la parte del pdf sein guardar la factura = else {
         localStorage.setItem(
           "factura",
           JSON.stringify({
             subtotal: subTotal,
             estado: 3,
             descuento: descuentototal,
             fechaPago,
             fechafactura: currentDate,
             financiado: 0,
             total,
             numeroFactura: Math.floor(1000 + Math.random() * 9000),
           })
         );
         // verifiquemos que la persona no exita en la base de datos
         if (!control || control == false) {
           const respersona = await PostPersona(formDataPersona);
           setMensaje(respersona.msg);
           localStorage.setItem("cliente", JSON.stringify(respersona));
           if (respersona.success) {
             setLoading(true);
             handleShowCotizacion();
             const rescliente = await PostCliente(respersona.data.idP);
             if (rescliente.success) {
               setLoading(false);
             }
           }
         } else {
           setLoading(true);
           handleShowCotizacion();
           // si la persona existe en la base de datos pero no es cliente
           if (idCliente === undefined || currentCliente?.length === 0) {
             const rescliente = await PostCliente(currentPersona?.idP);
             if (rescliente.success) {
               setLoading(false);
             }
           } else {
             setTimeout(() => {
               setLoading(false);
             }, 3000);
           }
         }
       }*/


      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  useEffect(() => {
    // Capturar la fecha actual
    const today = new Date();
    setCurrentDate(today.toLocaleDateString()); // Formato de fecha actual
  }, []);

  const verificarfactura = async () => {
    if (idfactura != null) {
      // window.location.href = `/generarfactura/${idfactura}`;
      await abrirPdfVentas(idfactura);
        navigate('/ver_cotizaciones');
    } else {
      window.location.href = `/generarfactura`;
    }
  };

  const limpiar = () => {
    localStorage.removeItem("cotizacion");
    setCotizacion([]);
  };

  const fetchTransporte = async (filters = {}) => {
    try {
      const res = await getTransporte(filters);
      setDatTransporte(res?.data);
    } catch (error) {
      console.error('Error al obtener los transportes:', error);
    }
  };

  useEffect(() => {
    fetchTransporte();
  }, []);


  const obtenerdatosTransporte = (idSeleccionado) => {
    const transporteEncontrado = dataTransporte.find(
      (item) => item.id === idSeleccionado
    );

    if (!transporteEncontrado) return null;

    return {
      nombre: transporteEncontrado.Persona?.nombre,
      apellido: transporteEncontrado.Persona?.apellido,
      celular: transporteEncontrado.Persona?.celular,

    };
  };
  return (
    <Fragment>
      <HeaderComponent>

        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          COTIZACION
        </TitleH2Component>
        <Link to="/ver_cotizaciones" className={`${stylebtn.btn} ${stylebtn.primary}`}>
          VER COTIZACIONES
        </Link>
      </HeaderComponent>
      <div className="conatiner-global pt-3 mb-5">
        <section>
          <form>
            <div className={`${stylegeneral.containerFormCotiza} mb-5`}>
              <div className={`container`}>

                <section className="border border-dark rounded p-3">
                  <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-3">
                    INFORMACION DEL COMPRADOR
                  </TitleH4Component>
                  <div className="row gy-3">
                    <div className="col-12 col-md-6 col-xl-3">
                      <label htmlFor="cedula" className="fw600 WorkSans color-madera">Documento*</label>
                      <input
                        type="text"
                        htmlFor="cudula"
                        className="form-control fw600 WorkSans"
                        placeholder="Ingrese la cc"
                        name="cedula"
                        value={formDataPersona.cedula}
                        onChange={handleInputChangePersona}
                        onKeyDown={handleKeyDown}
                      />
                      <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
                        {mensaje}
                      </ParrafoComponent>
                    </div>
                    <div className="col-12 col-md-9  ">
                      <button
                        type="button"
                        className={` btn ${stylebtn.btn} ${stylebtn.primary}`}
                        onClick={verificarCliente}
                      >
                        Verificar cliente
                      </button>
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Nombre*"
                        placeholder="Nombre:"
                        styleLabel="fw600 WorkSans"
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.nombre}
                        name="nombre"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Apellidos*"
                        placeholder="Primer Apellido:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.apellido}
                        name="apellido"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Direccion"
                        placeholder="Direccion:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.direccion}
                        name="direccion"
                        onChange={handleInputChangePersona}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Celular"
                        placeholder="Celular:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataPersona.celular}
                        name="celular"
                        onChange={handleInputChangePersona}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Quien recibe"
                        placeholder="Quien recibe:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataFactura.quien_recibe}
                        name="quien_recibe"
                        onChange={handleInputChangeFactura}
                      />
                    </div>

                    <div className="col-12 col-md-6 col-xl-3">
                      <InputComponent
                        label="Direccion de envio"
                        placeholder="Direccion de envio:"
                        styleLabel="fw600 WorkSans"
                        styleGroup=""
                        htmlFor="bloque"
                        type="text"
                        value={formDataFactura.direccion_envio}
                        name="direccion_envio"
                        onChange={handleInputChangeFactura}
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div className={`${stylegeneral.hija_2} d-none`}>
                <label className="form-label fw-bold ">{currentDate}</label>
              </div>
            </div>
          </form>
        </section>
        <section>
          <div className="container-fluid">
            <section className="mb-1 border border-dark rounded p-2">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
                REGISTRAR PRODUCTO A COTIZAR
              </TitleH4Component>
              <div className="row gy-3">
                <div className="col-12 col-md-6 col-xl-3 ">
                  <SelectComponent
                    label="Clase de madera*"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="Clase"
                    options={optionsclass}
                    name="clase"
                    value={selectedOptionClass}
                    capOpcions={setSelectedOptionClass}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Tipo de madera*"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="tipo"
                    options={optionstype}
                    name="tipo"
                    value={selectedOptionType}
                    capOpcions={setSelectedOptionType}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Dimension*"
                    styleLabel="color-madera fw600"
                    /*options={options}*/
                    customPlaceholder="dimension"
                    options={dimensionOpcion}
                    name="dimension"
                    value={selectedOptionDimension}
                    capOpcions={setSelectedOptionDimension}
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Cantidad*"
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    styleGroup=""
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={cantidad}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-12  my-3 d-flex  justify-content-end">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.primary} `}
                    onClick={aggCotizacion}
                  >
                    AGREGAR
                  </button>
                </div>
              </div>
            </section>
          </div>
        </section>
        <section>
          <div className="table-responsive mt-4">
            <table className="table table-bordered tableGeneral">
              <thead>
                <tr>
                  <th scope="col" className="color-madera">
                    Cantidad
                  </th>
                  <th scope="col" className="color-madera">
                    Descripción
                  </th>
                  <th scope="col" className="color-madera">
                    Valor por Unidad
                  </th>
                  <th scope="col" className="color-madera">
                    Valor Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {cotizacion.map((item, index) => {
                  return (
                    <tr key={index}>
                      <th>{item?.pendientePorEntregar}</th>
                      <td>
                        {item?.tipo} {item?.clase} {item?.dimension}
                      </td>
                      <td>
                        {Number(item?.valorPorUnidad).toLocaleString("es-ES")}
                      </td>
                      <td>
                        $
                        {Number(item?.valorTotalPorProducto).toLocaleString(
                          "es-ES"
                        )}
                      </td>
                      <td>
                        <button
                          className={`${styleBtn.btn_desnudo} ${styleBtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                          onClick={() => handleShowEliminar(item)}
                        >
                          <Icon icon="majesticons:delete-bin" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">SUBTOTAL</td>
                  <td>$ {Number(subTotal).toLocaleString("es-ES")}</td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">DESCUENTO</td>
                  <td>
                    ${" "}
                    {Number(
                      checkboxes.isCheckedDescuento ? descuento : 0
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">TRANSPORTE</td>
                  <td>
                    ${" "}
                    {Number(
                      checkboxes.isTransporte ? formDataFactura.transporte : 0
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">PENDIENTE DE PAGO</td>
                  <td>
                    ${" "}
                    {Number(
                      checkboxes.isCheckedpago ? (subTotal - descuento) + Number(formDataFactura.transporte) - totalPago : 0
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
                <tr className="d-none">
                  <td colSpan="3"></td>
                  <td className="text-right">PENDIENTE POR ENTREGA</td>
                  <td>80</td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">TOTAL</td>
                  <td
                    style={{
                      backgroundColor: "lightgreen",
                      fontWeight: "bold",
                    }}
                  >
                    ${" "}
                    {(
                      Number(subTotal) +
                      Number(formDataFactura.transporte) -
                      Number(descuento)
                    ).toLocaleString("es-ES")}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <form action="">
            <button
              type="button"
              className={` ${stylebtn.btn} ${stylebtn.primary} `}
              onClick={limpiar}
            >
              Limpiar
            </button>
          </form>
        </section>

        <form action="" onSubmit={craeteCotizacion}>
          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">
            {mensaje}
          </ParrafoComponent>

          <div className="d-md-flex justify-content-between align-items-end mt-5 ">
            <div className="">
              <div className="mb-1">
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="isCheckedpago"
                  checked={checkboxes.isCheckedpago}
                  onChange={handleCheckboxChange}
                />
                <label className="color-dark  fw700 me-2" htmlFor="recorddat">
                  Abonar
                </label>
              </div>

              {checkboxes.isCheckedpago && (
                <div className="d-flex flex-column">
                  <MoneyInputComponent
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    styleGroup="mt-3 mt-sm-0 me-3 mb-3"
                    htmlFor="pago"
                    type="number"
                    name="totalPago"
                    value={totalPago}
                    onChange={handleInputPago}
                  />
                  <InputComponent
                    label="Solo si la factura es financiada se agregan los siguentes campos"
                    placeholder="Cantidad a financiar"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="date"
                    name="fechapago"
                    value={fechaPago}
                    onChange={handleInputChangefechapago}
                  />
                  <textarea
                    label="descripcion"
                    name="descripcionAbono"
                    placeholder="Descripción"
                    className="form-control mb-2"
                    rows={3}
                    value={descripcionAbono}
                    onChange={handleChangeDescripcion}

                  ></textarea>
                </div>
              )}

              <div className="mb-1">
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="isCheckedDescuento"
                  checked={checkboxes.isCheckedDescuento}
                  onChange={handleCheckboxChange}
                />

                <label className="color-dark  fw700 me-2" htmlFor="recorddat">
                  Descuento
                </label>
              </div>

              {checkboxes.isCheckedDescuento && (
                <div className="">
                  <MoneyInputComponent
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    styleGroup="mt-2  mb-2"
                    htmlFor="descuento"
                    type="number"
                    name="descuento"
                    value={descuento}
                    onChange={handleInputChangedescuento}
                  />
                </div>
              )}

              <div className="mb-1">
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="isTransporte"
                  checked={checkboxes.isTransporte}
                  onChange={handleCheckboxChange}
                />
                <label className="color-dark  fw700 me-2" htmlFor="recorddat">
                  Transporte
                </label>
              </div>

              {checkboxes.isTransporte && (
                <div>
                  <MoneyInputComponent
                    label="Costo"
                    placeholder="Cant."
                    styleLabel="fw600 WorkSans"
                    styleGroup="mt-2  mb-2"
                    htmlFor="transporte"
                    type="number"
                    name="transporte"
                    value={formDataFactura.transporte}
                    onChange={handleInputChangeFactura}
                  />

                  <SelectComponent
                    label="Transporte"
                    styleGroup={`${stylegenral.wselect}`}
                    styleLabel="fw600 WorkSans color-madera"
                    options={dataTransporte.map((transporte) => ({
                      value: transporte.id,
                      label: transporte?.Persona?.nombre + ' ' + transporte?.Persona?.apellido
                    }
                    ))}

                    capOpcions={(v) => {
                      setTransporte(v);
                      const datos = obtenerdatosTransporte(v);

                      if (datos) {
                        setDataConductor(datos);
                      }
                    }}
                    customPlaceholder="Seleccionar"

                    name="transporte"
                    value={dataTransporte.find(o => o.value == transporte) || null}

                    isClearable
                  />
                  {dataConductor?.nombre && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans my-2">
                    Nombre: {dataConductor?.nombre}  {dataConductor?.apellido}
                  </ParrafoComponent>}
                  {dataConductor?.celular && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans mb-2">
                    Celular: {dataConductor?.celular}
                  </ParrafoComponent>}

                </div>
              )

              }
            </div>

            <button
              type="submit"
              className={`btn mt-4 mt-md-0 ${stylebtn.btn} ${stylebtn.primary} `}
            >
              OK
            </button>
          </div>
        </form>
      </div>

      {/** modal ingresar informacion del cliente **/}
      <section>
        <ModalGeneralComponent
          ModalHeader={false}
          titulo="Información del cliente"
          styleGroup={`d-flex align-items-center modal-general `}
          styleBody={`${"bg-gris-modal "}`}
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showCotizacion}
          handleClose={handleCloseCotizacion}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <div>
              <div className="d-flex justify-content-end mb-0 align-items-center mb-3">
                <button
                  type="button"
                  onClick={verificarfactura}
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                >
                  Generar factura
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                  onClick={handleCloseCotizacion}
                >
                  <Icon icon="mdi:close-thick" />
                </button>
              </div>
              <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                ¡¡Cotizacion realizada con éxito!!
              </TitleH2Component>
            </div>
          )}
        </ModalGeneralComponent>
      </section>

      {/** modal eliminar un producto del carrito **/}
      <section>
        <ModalGeneralComponent
          styleGroup="d-flex align-items-center modal-general "
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showEliminar}
          handleClose={handleCloseEliminar}
        >
          <form action="">
            <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar este producto ${currentCarrito?.tipo} ${currentCarrito?.clase} ?`}</TitleH2Component>

            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleCloseEliminar}
                className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={eliminarItem}
                className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
              >
                SI
              </button>
            </div>
          </form>
        </ModalGeneralComponent>
      </section>
    </Fragment>
  );
};
export default CotizacionPage;
